import { gql } from "@apollo/client";

export const GET_ALL_PRINTERS = gql`
  query printers(
    $pagination: PaginationInput
    $filter: FilterInput
    $sort: SortInput
  ) {
    printers(pagination: $pagination, filter: $filter, sort: $sort) {
      pagination {
        page
        limit
        total
      }
      printers {
        _id
        name
        brand
        images
        featuredImage
        width
        length
        height
        weight
        comments
        commentCount
        ownerId
        supportedFiles
        starRatingCount
        averageStarRating
        postalAddress
        postServiceCode
        countryCode
        country
        postalState
        postalCity
        postalStreet
        active
        filaments {
          name
          price
          colors
        }
        owner {
          _id
          firstName
          lastName
          totalLikes
          likedBy
        }
      }
    }
  }
`;
export const GET_SINGLE_PRINTER = gql`
  query printer($printerId: ID!) {
    printer(printerId: $printerId) {
      _id
      name
      brand
      featuredImage
      images
      length
      height
      width
      weight
      comments
      commentCount
      supportedFiles
      starRatingCount
      averageStarRating
      postalAddress
      postServiceCode
      country
      postalState
      postalCity
      postalStreet
      countryCode
      active
      ownerId
      filaments {
        name
        price
        colors
      }
      owner {
        _id
        firstName
        lastName
        totalLikes
        likedBy
      }
    }
  }
`;
export const MY_PRINTERS = gql`
  query myPrinters {
    myPrinters(pagination: { page: 1, limit: 100 }) {
      pagination {
        page
        limit
        total
      }
      printers {
        _id
        name
        brand
        length
        images
        width
        height
        comments
        commentCount
        starRatingCount
        averageStarRating
        postalAddress
        postServiceCode
        country
        postalState
        postalCity
        postalStreet
        countryCode
        active
        provideShipping
        filaments {
          name
          price
          colors
        }
        owner {
          firstName
          likedBy
        }
        ownerId
        featuredImage
        supportedFiles
      }
    }
  }
`;
